import { MinusCircleIcon, PlusCircleIcon } from "@heroicons/react/24/outline";
import {
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionPanel,
  Box,
  Flex,
  Heading,
  Icon,
  Text,
} from "@highoutput/ui-components";
import type { FC } from "react";
import For from "../utilities/for";

type FaqsProps = {
  data: {
    id: number;
    question: string;
    answer: string[];
  }[];
};
const Faqs: FC<FaqsProps> = ({ data }) => {
  return (
    <Box
      paddingTop={{
        base: "60px",
        lg: "80px",
        xl: "128px",
      }}
      paddingBottom={{
        base: "140px",
        lg: "124px",
        xl: "296px",
      }}
      paddingX={{
        base: "1rem",
        lg: "24px",
        xl: "unset",
      }}
      bgColor="rgba(240,237,236,0.2)"
    >
      <Box
        marginX="auto"
        maxWidth={{
          base: "375px",
          lg: "1024px",
          xl: "1180px",
        }}
      >
        <Flex justifyContent="center">
          <Box
            w={{ base: "auto", lg: 1000, xl: 1120 }}
            mt={{ base: 6, lg: 0 }}
            fontFamily="'Inter', sans-serif"
          >
            <Heading
              variant={{ base: "40/44", xl: "56/64" }}
              fontWeight={400}
              mb={{ base: "3rem", lg: "4rem" }}
              color="rgb(13,48,80)"
              textAlign="center"
            >
              Frequently asked questions
            </Heading>
            <Accordion allowToggle>
              <For each={data}>
                {({ question, answer, id }) => (
                  <AccordionItem
                    fontSize="18px"
                    lineHeight="28px"
                    borderColor="rgba(240,237,236,0.4)"
                    paddingX={0}
                    border={0}
                    pb="1.5rem"
                  >
                    {({ isExpanded }) => (
                      <>
                        <AccordionButton
                          display="flex"
                          gap="24px"
                          justifyContent="space-between"
                          fontSize="inherit"
                          lineHeight="inherit"
                          textAlign="unset"
                          padding={0}
                          _hover={{
                            bgColor: "unset",
                          }}
                          borderTop={id === 1 ? "" : "1px solid"}
                          borderColor="rgba(13,48,80,0.2)"
                        >
                          <Text
                            fontWeight={{ base: 500, lg: 600 }}
                            fontSize={{ base: "18px", lg: "20px" }}
                            lineHeight={{ base: "20px", lg: "24px" }}
                            data-testid={`faq.${id}.question`}
                            pt={{ base: "1.5rem", lg: "1rem" }}
                            letterSpacing={{ base: "-0.012em" }}
                          >
                            {question}
                          </Text>
                          <Icon
                            as={isExpanded ? MinusCircleIcon : PlusCircleIcon}
                            stroke="rgba(13,48,80,0.8)"
                            height="20px"
                            width="20px"
                          />
                        </AccordionButton>

                        <AccordionPanel
                          color="rgba(13,48,80,0.6)"
                          padding={0}
                          marginTop="8px"
                          display="flex"
                          flexDirection="column"
                        >
                          <For each={answer}>
                            {(ans) => (
                              <Text
                                w={{ base: 320, lg: 928, xl: 1072 }}
                                variant={{
                                  base: "16/24",
                                  lg: "20/32",
                                }}
                                mb="1rem"
                                color="rgba(13,48,80,0.8)"
                                data-testid={`faq.${id}.answer`}
                              >
                                {ans}
                              </Text>
                            )}
                          </For>
                        </AccordionPanel>
                      </>
                    )}
                  </AccordionItem>
                )}
              </For>
            </Accordion>
          </Box>
        </Flex>
      </Box>
    </Box>
  );
};
export default Faqs;
